export default {"src":"/app/presentation/_next/static/media/image_fallback_error_editor.7f6e938a.svg","height":757,"width":814,"blurWidth":0,"blurHeight":0};